import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { Handle } from "reactflow";
import { Tooltip } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export const HandleDot = ({ position, type, id, onAdd, style, addVisible }) => {
  const { darkMode } = useTheme();

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#121212" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#fafafa" : "#000000",
        secondary: darkMode ? "#fafafa" : "#666666",
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: darkMode ? "#333333" : "rgba(97, 97, 97, 0.92)",
            color: darkMode ? "#fafafa" : "#ffffff",
            fontSize: "0.75rem",
          },
          arrow: {
            color: darkMode ? "#333333" : "rgba(97, 97, 97, 0.92)",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div>
        {addVisible && (
          <div style={{ ...style, top: (style?.top || 10) - 10 }}>
            <Tooltip title={"Add new node1"}>
              <ControlPointIcon
                onClick={(e) => {
                  console.log("asdasdasdasdasdd");
                  onAdd(e);
                }}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 2,
                  transform: "translateY(-50%)",
                  fontSize: 12,
                  color: darkMode ? "#fafafa" : "#000000",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </div>
        )}
        <Handle id={id} type={type} position={position} style={style} />
      </div>
    </ThemeProvider>
  );
};
